import { IMapper } from 'src/core/sharepoint/model/mapper';
import { QuickLinks } from '../models/quick-links';
import { quickLinksConstants } from './quick-links-const';

export class QuickLinksMapper implements IMapper {
    
    convertListItems(items: SP.ListItemCollection<any>): QuickLinks[] {

        let quickLinksItems: Array<QuickLinks> = new Array<QuickLinks>();
        if (items != null) {
            let listItemsEnumerator = items.getEnumerator();

            while (listItemsEnumerator.moveNext()) {

                quickLinksItems.push(this.convertItem(listItemsEnumerator.get_current()));
            }
        }
        return quickLinksItems;
    }

    convertItem(item: SP.ListItem<any>): QuickLinks {
        let quickLinks: QuickLinks = null;
        if (item != null) {
            quickLinks = new QuickLinks();

            quickLinks.title = item.get_item(quickLinksConstants.list.fields.title);
            quickLinks.logo = item.get_item(quickLinksConstants.list.fields.logo);
            quickLinks.url = item.get_item(quickLinksConstants.list.fields.url).get_url();
        }
        return quickLinks;
    }

    GetData(item: any): string {
        if (item != null) {
            var arr: string[] = new Array();
            for (let index = 0; index < item.length; index++) {

                arr.push(item[index].get_lookupValue());
            }
            return arr.join(',')
        }
        return "";
    }
}
